<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <el-row style="height: 36px">
          <el-form :inline="true" :model="searchCondition">

            <el-form-item class="elformItem" v-for="(item,index) in sccomData"
              :label="item.type=='button'?'':item.label" :key="index">
              <el-select :filterable="item.filterable" clearable @change="event_change(item)" v-if="item.type=='select'"
                :placeholder="item.placeholder?item.placeholder:item.label" v-model="item.val">
                <el-option v-for="(item_type,index_type) in item.typeData" :label="item_type.label"
                  :value="item_type.val" :key="index_type"></el-option>
              </el-select>

            </el-form-item>

            <el-form-item>
              <el-button @click="searchButton" style="color: #1890ff">查询</el-button>
            </el-form-item>

          </el-form>
        </el-row>

        <div style="text-align: right;margin: 5px 0;">
        </div>

        <div class="main-table-header">
					<el-tabs v-model="activeTabName" type="card" @tab-click="tabClick">
						<el-tab-pane v-for="(item,index) in tabs" :key="index" :name='item.name' :label="item.title">
						</el-tab-pane>
					</el-tabs>
          <span>
            <el-button v-if="userPermissions.indexOf('AutoExa_add') != -1" type="primary" @click="toggleOEMDialog('add')">新增白名单</el-button>
          </span>
          
				</div>

        <ApeTable v-if="userPermissions.indexOf('AutoExa_list') != -1" ref="apeTable" :data="companyList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData"
          @switchPaging="switchPaging" highlight-current-row>
          <el-table-column v-if="this.activeTabName==='0'" label="是否需要风控">
            <template slot-scope="scope">
              <el-switch disabled v-model="scope.row.is_rick" active-value='1' inactive-value="2">
              </el-switch>
            </template>
          </el-table-column>
          <!-- <el-table-column label="是否自动审核">
            <template slot-scope="scope">
              <el-switch disabled v-model="scope.row.is_auto_examine" active-value='1' inactive-value="2">
              </el-switch>
            </template>
          </el-table-column> -->
          <el-table-column v-if="buttonType=='text'" header_align='center' align='center' label="操作">
            <template slot-scope="scope">
              <span class="update-btn">
                <el-button size="mini" v-if="userPermissions.indexOf('AutoExa_edit') != -1" type="primary" @click="updateChannel(scope.row)">修改</el-button>
                <el-popover placement="top" width="150" v-model="scope.row.visible">
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                  </div>
                  <el-button slot="reference" type="danger" size="mini" v-if="userPermissions.indexOf('AutoExa_delete') != -1">删除</el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>

    <CreateEdit :dialog-data="openOEMDialog" ref="oemTable"
      @dialogConfirm="addSuccess" :id='id' :buttonArr="buttonArr" :comData="comData"
      @dialogClose="dialogClose"></CreateEdit>
  </div>
</template>

<script>
  import PageHeaderLayout from '@/layouts/PageHeaderLayout'
  import ApeTable from '@/components/ApeTable'
  import DatePicker from '@/components/DatePicker.vue'
  import {
    mapGetters,
    mapState
  } from 'vuex'
  import CreateEdit from "./CreateEdit.vue";

  export default {
    components: {
      PageHeaderLayout,
      ApeTable,
      DatePicker,
      CreateEdit,
    },
    data() {
      return {
        activeTabName: '0',
		tabs: [{
				title: '自动审核白名单',
				name: '0',
			},
			{
				title: '风控白名单',
				name: '1',
			}
		],
        id: '',
        allCompany: [],
        allTaxSource: [],
        buttonArr: [{
          label: '确定',
          type: 'primary',
          flag: 'add'
        }],
        sccomData: [{
          label: '税源地',
          type: 'select',
          field: 'settlement_id',
          val: '',
          placeholder: '请选择税源地',
          typeData: [],
          required: true,
          filterable: true
        }, {
          label: '服务公司',
          field: 'company_id',
          val: '',
          required: true,
          placeholder: '请选择服务公司',
          type: 'select',
          typeData: [],
          filterable: true
        }],
        comData: [{
            label: '税源地',
            type: 'select',
            field: 'settlement_id',
            val: '',
            placeholder: '请选择税源地',
            typeData: [],
            required: true,
            filterable: true
          }, {
            label: '服务公司',
            field: 'company_id',
            val: '',
            required: true,
            placeholder: '请选择服务公司',
            type: 'select',
            typeData: [],
            filterable: true
          },
          // {
          //   label: '是否自动审核',
          //   field: 'is_auto_examine',
          //   activeValue:1,
          //   inactiveValue:2,
          //   val: 2,
          //   required: true,
          //   type: 'switch',
          // },
          {
            label: '是否需要风控',
            field: 'is_rick',
            activeValue:1,
            inactiveValue:2,
            val: 2,
            required: true,
            type: 'switch',
          }
        ],
        openOEMDialog: {
          visible: false,
          width: '50%',
          loading: false,
          modal: true,
          confirmText: '提交',
          title: '新增税源地'
        },
        // 搜索条件
        searchCondition: {},
        loadingStaus: true,
        columns: [{
            title: '税源地名称',
            value: 'channel_name',
            width: 270,
            header_align: 'center',
            align: 'center',
          },
          {
            title: '服务公司',
            value: 'name',
            header_align: 'center',
            align: 'center',
          },
          {
            title: '创建时间',
            value: 'created_at',
            header_align: 'center',
            align: 'center',
          }
        ],
        // 表格列表数据
        companyList: [],
        // 分页信息
        pagingData: {
          is_show: true,
          layout: 'total, sizes, prev, pager, next, jumper',
          total: 0
        },
        // 分页的offset,序号列使用
        offset: 0,
        selectTaxSourceList:[],
        selectCompanyList:[]
      }
    },

    computed: {
      ...mapGetters(['userPermissions', 'buttonType']),
      ...mapState({
        userInfo: state => state.userInfo,
      }),
    },
    watch: {
      "$route.matched": function(n, o) {
        console.log(o)
        if (n.length === 2) {
          this.init()
        }
      }
    },
    methods: {
      tabClick() {
		this.init('search')
		if(this.activeTabName === '1'){
			this.comData = [{
              label: '税源地',
              type: 'select',
              field: 'settlement_id',
              val: '',
              placeholder: '请选择税源地',
              typeData: this.selectTaxSourceList,
              required: true,
              filterable: true
            }, {
              label: '服务公司',
              field: 'company_id',
              val: '',
              required: true,
              placeholder: '请选择服务公司',
              type: 'select',
              typeData: this.selectCompanyList,
              filterable: true
            }
          ]
		}else{
			this.comData = [{
              label: '税源地',
              type: 'select',
              field: 'settlement_id',
              val: '',
              placeholder: '请选择税源地',
              typeData: this.selectTaxSourceList,
              required: true,
              filterable: true
            }, {
              label: '服务公司',
              field: 'company_id',
              val: '',
              required: true,
              placeholder: '请选择服务公司',
              type: 'select',
              typeData: this.selectCompanyList,
              filterable: true
            },
            {
              label: '是否需要风控',
              field: 'is_rick',
              activeValue:1,
              inactiveValue:2,
              val: 2,
              required: true,
              type: 'switch',
            }
          ]
		}
      },

      // 相应删除按钮
      async deleteButton(id) {
        let result = null
        if(this.activeTabName === '1'){
          result = await this.$api.deleteRiskWhiteList(id)
        } else {
          result = await this.$api.deleteExamineWhiteList(id)
        }
        if (result) {
          await this.init()
        }
      },

      // 处理函数
      event_change() {

        let obj = {}
        this.sccomData.map((item) => {
          obj[item.field] = item.val
          if (obj[item.field] === '' || obj[item.field] === undefined) {
            delete obj[item.field]
          }
        })

        // if (item.field == 'settlement_id') {
        //   this.searchCondition.company_id = ''
        //   this.allCompanyList('search')
        // }

        this.searchCondition = obj
      },

      async allTaxSourceList() {
        const result = await this.$api.tenantCategoryList()
        let allTaxSource = this.allTaxSource.concat(result)
        let arr = []

        allTaxSource.map(item => {
          let obj = {
            label: item.channel_name,
            val: item.channel_account
          }
          arr.push(obj)
        })
        this.comData[0].typeData = arr
        this.selectTaxSourceList = arr
      },

      async allCompanyList() {
        let obj = {}

        // if (this.searchCondition.settlement_id) {
        //   obj.channel_account = this.searchCondition.settlement_id
        // }

        const data = await this.$api.companysBySett(obj);
        let allCompany = this.allCompany.concat(data)
        let arr = []
        allCompany.map(item => {
          let obj = {
            label: item.name,
            val: item.id
          }
          arr.push(obj)
        })
        arr.unshift({
          label: '全部',
          val: '0'
        })
		this.comData[1].typeData = arr
        this.sccomData[1].typeData = arr
        this.selectCompanyList = arr;
      },

      async updateChannel(e) {
        this.id = e.id.toString();
        let {
          settlement_id,
          company_id,
          is_rick,
          is_auto_examine,
        } = e
        let obj = {
          settlement_id,
          is_rick,
          company_id,
          is_auto_examine
        }
        this.comData.map(item => {
          if (item.type == 'switch') {
            item.val = +obj[item.field]
          } else {
            item.val = obj[item.field]
          }
        })

        this.comData.map(item => {
          if (item.val === '') {
            item.val = '暂无'
          }
        })
        // if(settlement_id){
        //   this.allCompanyListEdit({
        //     settlement_id:settlement_id
        //   })
        // }
        this.toggleOEMDialog()
      },

      addSuccess() {
        this.dialogClose()
        this.init()
      },
      dialogClose() {
        this.id = ''
        this.openOEMDialog.visible = false
      },

      toggleOEMDialog(type) {

        if (type === 'add') {
          this.comData.map(item => {
            if (item.type == 'switch') {
              item.val = 2
            } else {
              item.val = ''
            }
          })
          this.openOEMDialog.title = `添加`
        } else {
          this.openOEMDialog.title = `修改`
        }
        this.openOEMDialog.type = this.activeTabName
        this.openOEMDialog.visible = true
      },

      // 搜索
      searchButton() {
        this.init('search')
      },
      // 切换页码操作
      async switchPaging() {
        this.init()
      },
      
      // 初始化列表
      async init(type) {
        let pagingInfo = this.$refs['apeTable']?.getPagingInfo(type) || {
					page_size: 10,
					current_page: 1
				}
        if (type == 'export') {
          pagingInfo.page_size = 50000
        } else {
          this.loadingStaus = true
        }
        if (type == 'search') {
          this.companyList = []
          pagingInfo.current_page = 1
        }
        let searchCondition = this.searchCondition;
        Object.assign(searchCondition, pagingInfo)
        let res = null
        if(this.activeTabName === '1'){
          res = await this.$api.getRiskWhiteList(searchCondition)
        }else{
          res = await this.$api.getExamineWhiteList(searchCondition)
        }
        let {
          data,
          pages
        } = res

        this.companyList = []
        this.$nextTick(() => {
          this.companyList = data
        })
        this.pagingData.total = pages.total
        this.offset = pages.offset
        this.loadingStaus = false
      },

      keyupSubmit() {
        document.onkeydown = () => {
          let _key = window.event.keyCode;
          if (_key === 13) {
            this.searchButton()
          }
        }
      },
    },
    created() {
      this.keyupSubmit()
    },
    mounted() {
      this.allCompanyList('init')
      this.allTaxSourceList()
      this.init()
    },
  }
</script>
<style lang="scss" scoped>
  .update-btn{
    /deep/ .el-button{
      margin-right: 10px;
    }
  }

  .main-table-header {
		display: flex;
		justify-content: space-between;
		padding-right: 20px;
		box-sizing: border-box;
	}

</style>
